import Keycloak from 'keycloak-js'

const keycloakURL = process.env.REACT_APP_KEYCLOAK_URL as string
const keycloakRealm = process.env.REACT_APP_KEYCLOAK_REALM as string
const keycloakClientId = process.env.REACT_APP_KEYCLOAK_CLIENT_ID as string

// Setup Keycloak instance as needed
// Pass initialization options as required or leave blank to load from 'keycloak.json'
const keycloak = new Keycloak({
	url: keycloakURL,
	realm: keycloakRealm,
	clientId: keycloakClientId,
})

export default keycloak
